// src/modules/admin/components/AdminStatsCard/index.js
import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import './styles.css';

const AdminStatsCard = ({ title, value, icon, subtitle, link, linkText }) => {
    const linkContent = link && linkText ? (
        <Link to={link} className="stats-card-link">
            {linkText} <i className="bi bi-arrow-right"></i>
        </Link>
    ) : null;

    return (
        <Card className="stats-card h-100">
            <Card.Body className="stats-card-body">
                <Card.Title className="stats-card-title">
                    <i className={`bi ${icon} stats-card-icon`}></i>
                    {title}
                </Card.Title>
                <div className="stats-card-value-wrapper">
                    <div className="stats-card-value">{value}</div>
                    {subtitle && <div className="stats-card-subtitle">{subtitle}</div>}
                </div>
            </Card.Body>
            {linkContent && (
                <Card.Footer className="stats-card-footer">
                    {linkContent}
                </Card.Footer>
            )}
        </Card>
    );
};

AdminStatsCard.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    icon: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    link: PropTypes.string,
    linkText: PropTypes.string,
};

AdminStatsCard.defaultProps = {
    subtitle: undefined,
    link: undefined,
    linkText: undefined,
};

export default AdminStatsCard;
